export default __webpack_public_path__ + "static/media/07.19cd78cb.jpg";